import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyNotice() {
  return (
    <div style={{ minHeight: '100vh', background: '#0f0f1a', padding: '6rem 1.5rem 4rem', color: '#cbd5e1' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <Link to="/" style={{ fontSize: 13, color: '#818cf8', textDecoration: 'none', display: 'inline-block', marginBottom: '2rem' }}>← Back</Link>

        <h1 style={{ color: '#f8fafc', fontSize: 30, fontWeight: 800, margin: '0 0 0.5rem' }}>Privacy Notice</h1>
        <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 2.5rem' }}>Last updated: April 2026 · public.privacy.education</p>

        {[
          {
            title: '1. Who we are',
            body: 'privacy.education is an interactive privacy literacy platform. This notice applies to public.privacy.education — the consumer-facing product where individuals learn about data privacy through games and simulations.',
          },
          {
            title: '2. What we collect',
            body: `When you create an account or use the platform we collect:
• Email address and display name (via AWS Cognito sign-up)
• Learning progress: XP earned, modules completed, and activity timestamps
• Payment information — processed entirely by Stripe. We store only your Stripe Customer ID and Subscription ID; we never see your card details
• Organisation membership details if you join a team (org ID, role, join method, join date)
• Technical metadata: your browser may send standard HTTP headers (user-agent, IP address) to our API — we do not log or store these beyond what AWS API Gateway retains for up to 7 days`,
          },
          {
            title: '3. How we use your data',
            body: `We use your data only to:
• Provide and personalise the learning experience (XP, leaderboards, progress tracking)
• Process and manage your subscription through Stripe
• Allow organisation administrators to view aggregate team progress
• Send transactional emails (e.g. account confirmation, password reset) via AWS Cognito
We do not use your data for advertising and we do not sell it to third parties.`,
          },
          {
            title: '4. Where your data is stored',
            body: 'All data is stored in AWS infrastructure located in Canada (ca-central-1 region). Authentication is handled by AWS Cognito (public pool). User and progress records are stored in Amazon DynamoDB. Payments are processed by Stripe (US).',
          },
          {
            title: '5. Data sharing',
            body: `We share data only with the following service providers under contract:
• AWS (Cognito, DynamoDB, API Gateway, S3, CloudFront) — infrastructure
• Stripe — payment processing
• Your organisation administrator — if you join an org, they can see your progress and XP within that org
We do not share data with any other third parties.`,
          },
          {
            title: '6. Data retention',
            body: 'Your account and associated data are retained for as long as you have an active subscription or account. If you cancel and request deletion, we will delete your data within 30 days. Contact us at the address below to request deletion.',
          },
          {
            title: '7. Your rights',
            body: `Depending on your jurisdiction you may have the right to:
• Access a copy of the personal data we hold about you
• Correct inaccurate data
• Request deletion of your data
• Object to or restrict certain processing
To exercise any of these rights, email us at privacy@privacy.education`,
          },
          {
            title: '8. Cookies',
            body: 'We do not use tracking or advertising cookies. We store your session token in browser localStorage solely to keep you signed in.',
          },
          {
            title: '9. Changes to this notice',
            body: 'We may update this notice as the platform evolves. Material changes will be communicated via email or an in-app banner.',
          },
          {
            title: '10. Contact',
            body: 'Questions about this notice? Email us at privacy@privacy.education',
          },
        ].map(({ title, body }) => (
          <section key={title} style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#e2e8f0', fontSize: 17, fontWeight: 700, margin: '0 0 0.5rem' }}>{title}</h2>
            <p style={{ fontSize: 14, lineHeight: 1.75, margin: 0, whiteSpace: 'pre-line' }}>{body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
